module.exports = __webpack_public_path__ + "img/noHandout.833748e8.png";